
import { Component,  OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd  } from '@angular/router';
import { PopoverController, NavParams, IonSlides, Platform, ModalController } from '@ionic/angular';
import { ViewerModalComponent } from 'ngx-ionic-image-viewer';
import { PedidoService } from 'src/app/servicios/pedido/pedido.service';
import { ProductoService } from 'src/app/servicios/producto.service';
import KeenSlider from "keen-slider"
import { CONFIGURATIONS } from 'src/constant/constantes';

@Component({
  selector: 'app-cajas',
  templateUrl: './cajas.component.html',
  styleUrls: ['./cajas.component.scss'],
})


export class CajasComponent implements OnInit {

  @ViewChild('IonSlides') slides: IonSlides;
 

 
  
  constructor(public poper: PopoverController, public navParams:NavParams, public productoService: ProductoService, 
              public pedidoService: PedidoService,  public platform: Platform,
              private router: Router, public modalController: ModalController,
              ) {
                
                //      this.disableBack();
              

          this.sliderConfig = {
              initialSlide: 0,
              speed: 400,
              slidesPerView: 1,
              autoplay: false,
              //zoom:{maxRatio: 4, },
              autoHeight: true,
              pager:true
            };
    

  }
//showSlide = false;  
producto;
json=[];
listaCajas;
configuracion = CONFIGURATIONS;
//////////////////////////////////////////////////////////////////////////////
//Stop the slide autoplay when the view will leave
  sliderConfig;
  showSlides=false;
 public ionViewWillEnter(){
   if (this.slides != undefined) {
     this.slides.update();
   }  
}

createSlider(wrapper) {
  new KeenSlider(wrapper.querySelector(".keen-slider"), {
    created: function (instance) {
      wrapper
        .querySelector(".arrow--left")
        .addEventListener("click", function () {
          instance.prev();
        });

      wrapper
        .querySelector(".arrow--right")
        .addEventListener("click", function () {
          instance.next();
        });
      var dots_wrapper = wrapper.querySelector(".dots");
      var slides = wrapper.querySelectorAll(".keen-slider__slide");
      slides.forEach(function (t, idx) {
        var dot = document.createElement("button");
        dot.classList.add("dot");
        dots_wrapper.appendChild(dot);
        dot.addEventListener("click", function () {
          instance.moveToIdx(idx);
        });
      });
      updateClasses(instance);
    },
    slideChanged(instance) {
      updateClasses(instance);
    }
  });

  function updateClasses(instance) {
    if (instance.track) {
      var slide = instance.track.details;// instance.details().relativeSlide;
    var arrowLeft = wrapper.querySelector(".arrow--left");
    var arrowRight = wrapper.querySelector(".arrow--right");
    slide.rel === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled");
    slide.rel === slide.slidesLength - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled");

    var dots = wrapper.querySelectorAll(".dot");
    dots.forEach(function (dot, idx) {
      idx === slide
        ? dot.classList.add("dot--active")
        : dot.classList.remove("dot--active");
    });
    }
    
  }
}

ngOnInit() {
  this.listaCajas = this.pedidoService.verCajas().then((e) => {
    this.json = e;
    document.getElementById("defaultOpen").click();
    setTimeout(() => {
     // this.json = pedidoService.cajas;
      document.querySelectorAll(".slider-wrapper").forEach((wrapper) => {
        this.createSlider(wrapper);
       // this.showSlide = true;
      });  
    },200 );
  });
     
  }
////////////////////////////////////////////////////////////////////////////////
disableBack() {
  document.addEventListener('backbutton', this.logger, false);
}
private logger() {}

async aceptarPopOver(imagen, precio, cod){
 // this.productoService.nuevaCaja(imagen, this.Mifrase, precio);
  this.poper.dismiss({
    imagen : JSON.stringify(imagen) , frase: this.Mifrase, precioBase: precio, cod: cod
  });

}
coun=0;
precioLetra = CONFIGURATIONS.precioLetraCaja;
letrasGratis = Number(CONFIGURATIONS.cantidadLetrasGratis);
Mifrase;
letrasExtras=0;
frase(event){
this.Mifrase = event.detail.value;
let fras = this.Mifrase.replace(/ /g, "");
if (fras.length > this.letrasGratis) {
  let adicional = Number(fras.length) - this.letrasGratis;
  this.letrasExtras = adicional * this.precioLetra;
  //this.calcularTotal();
}else{
  this.letrasExtras=0;
  //this.calcularTotal();
}
}

async openViewer(img, titulo, precio) {
  const modal = await this.modalController.create({
    component: ViewerModalComponent,
    componentProps: {
      src: img, //this.imgUrl, // required
      title: titulo, // optional
      text: "Precio: S/. "+precio, // optional
    },
    cssClass: 'ion-img-viewer', // required
    keyboardClose: true,
    showBackdrop: true,
  });

  return await modal.present();
}

 dismissModal() {
  /*if (currentModal) {
    currentModal.dismiss().then(() => { currentModal = null; });
  }*/
}

async cerarPopOver(){  
   this.poper.dismiss(); 
 }
}
